<template>
	<div class="row filter-nav">
		<div class="columns column12">
			<span
				class="button filter-button"
				:class="{ active: filter === 'showAll' }"
				@click="$emit('change-filter', 'showAll')"
				>{{ $t('showAll') }}</span
			>
			<span
				v-for="item in items"
				:key="item"
				class="button filter-button"
				:class="{ active: filter === item }"
				@click="$emit('change-filter', item)"
				>{{ item }}</span
			>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

defineEmits(['change-filter']);
</script>

<style lang="scss" scoped>
.filter-nav {
	margin: 0 auto 50px;
	display: flex;
	flex-wrap: wrap;

	.filter-button {
		border: 1px solid #111;
		color: #111;
		cursor: pointer;
		display: inline-block;
		font-size: 13px;
		font-weight: 700;
		letter-spacing: 1px;
		margin: 10px 10px 10px 0;
		padding: 10px 35px;
		position: relative;
		text-transform: uppercase;

		&:hover,
		&.active {
			background: $primary-color;
			border-color: $primary-color;
			color: #fff;
		}
	}

	span {
		cursor: pointer;
		padding: 10px 15px;
		text-transform: uppercase;
		margin: 3px 3px 0 0;
		transition: all 0.3s ease-in-out;
		background: $primary-background-color;
		color: #000;
		text-decoration: none;
		font-weight: 700;
		letter-spacing: 1px;
		font-size: 13px;

		&.active {
			background: $primary-color;
			border-color: $primary-color;
			color: #fff;
		}
	}
}
</style>
